import { axiosInstance } from "../../App";
import {
    CreateFinancerPreLiquidationRequestDTO,
    DeletePreLiqDetailResultDTO,
    HonorariumPreLiquidationDTO,
    HonorariumPendingProfessionalSummaryDTO,
    HonorariumPreLiquidationDetailDTO,
    HonorariumPreLiquidationItemDTO,
    PreLiquidationFilters,
} from "../../dto/HonorariumPreLiquidationDTO";

/** Historial paginado. Las pre-liquidaciones canceladas no vienen: para el usuario están eliminadas. */
export function getPreLiquidations(offSet: number, pageSize: number, params?: PreLiquidationFilters): Promise<HonorariumPreLiquidationDTO[]> {
    return axiosInstance.get('/api/secured/honorariumprequidation/getPreLiquidations', {
        params: {
            offset: offSet,
            pageSize,
            status: params?.status ?? undefined,
            billingEntityId: params?.billingEntityId ?? undefined,
            professionalId: params?.professionalId ?? undefined,
        },
    }).then(r => r.data);
}

/** Cabecera de una pre-liquidación (datos, estado, total y conteo de ítems). */
export function getPreLiquidation(preLiqId: number): Promise<HonorariumPreLiquidationDTO> {
    return axiosInstance.get('/api/secured/honorariumprequidation/getPreLiquidation', {
        params: { preLiqId },
    }).then(r => r.data);
}

export function getPreLiquidationItems(preLiqId: number): Promise<HonorariumPreLiquidationItemDTO[]> {
    return axiosInstance.get('/api/secured/honorariumprequidation/getPreLiquidationItems', {
        params: { preLiqId },
    }).then(r => r.data);
}

export function getPreLiquidationItemDetails(preLiqItemId: number): Promise<HonorariumPreLiquidationDetailDTO[]> {
    return axiosInstance.get('/api/secured/honorariumprequidation/getPreLiquidationItemDetails', {
        params: { preLiqItemId },
    }).then(r => r.data);
}

export function cancelPreLiquidation(preLiqId: number) {
    return axiosInstance.delete('/api/secured/honorariumprequidation/cancelPreLiquidation', {
        params: { preLiqId },
    }).then(r => r.data);
}

/** Ítems de pre-liquidación pendientes de la entidad de la liquidación. */
export function getPendingPreLiqItemsForLiquidation(liquidationId: number): Promise<HonorariumPreLiquidationItemDTO[]> {
    return axiosInstance.get('/api/secured/honorariumprequidation/getPendingItemsForLiquidation', {
        params: { liquidationId },
    }).then(r => r.data);
}

/** Un resumen por profesional con ítems pendientes de pre-liquidaciones activas. */
export function getPendingProfessionalSummary(billingEntityId: number): Promise<HonorariumPendingProfessionalSummaryDTO[]> {
    return axiosInstance.get('/api/secured/honorariumprequidation/getPendingProfessionalSummary', {
        params: { billingEntityId },
    }).then(r => r.data);
}

export function getPendingPreLiqItemsForBillingEntity(billingEntityId: number, professionalId?: number): Promise<HonorariumPreLiquidationItemDTO[]> {
    return axiosInstance.get('/api/secured/honorariumprequidation/getPendingItemsByBillingEntity', {
        params: { billingEntityId, professionalId },
    }).then(r => r.data);
}

/** Si algún ítem ya no está pendiente, no se agrega ninguno (PRELIQUIDATION_ITEMS_UNAVAILABLE). */
export function addPreLiqItemsToLiquidation(body: { liquidationId: number; preLiqItemIds: number[] }): Promise<void> {
    return axiosInstance.post('/api/secured/honorariumprequidation/addPreLiqItemsToLiquidation', body)
        .then(r => r.data);
}

export function deletePreLiqDetail(detailId: number): Promise<DeletePreLiqDetailResultDTO> {
    return axiosInstance.delete('/api/secured/honorariumprequidation/deletePreLiqDetail', {
        params: { detailId },
    }).then(r => r.data);
}

export function createFinancerPreLiquidation(body: CreateFinancerPreLiquidationRequestDTO) {
    return axiosInstance.post('/api/secured/honorariumprequidation/createFinancerPreLiquidation', body)
        .then(r => r.data);
}
